import React, { Component } from 'react';
import { connect } from "react-redux"
import NumberFormat from "react-number-format";

import moment from 'moment';

import { getLoggedProfile } from "../../actions/sessionAct";
import { initApp } from "../../actions/appInitAct";

import { getBalance, getInvoiceByMonth } from '../../model/wallet';

import { TPlatformType } from '../common/common';
import { LoadingPage } from "../common/loading"
import { commonErr } from "../common/errors";

import Header from "../common/header";
import Footer from "../common/footer";
import SideBar from '../common/sidebar';
// import { MessageLine } from "../common/messagebox";
// import { LoadingPage, LoadingInline } from "../common/loading";


class MyMonthlyReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			invalidWidth: false,
		}		
		this.getTotalTrasactionAmount = this.getTotalTrasactionAmount.bind(this);
		this.getProfile = this.getProfile.bind(this);
	}

	componentDidMount() {	
		if (!this.props.session.profile.info || !this.props.session.profile.info.uid) {
				this.getProfile();
		}
		const monthInMiliseconds = moment(this.props.match.params.month, ["MM-YYYY"]).valueOf();
		this.getWalletInfo(monthInMiliseconds);	
		
	}

	getProfile() {
        this.props.dispatch(getLoggedProfile());
    }

	getTotalTrasactionAmount(listTransaction){
		var total = 0;
		var i;
		if(listTransaction && listTransaction.length > 0) {
			for (i = 0; i < listTransaction.length; ++i) {
				var transaction = listTransaction[i];
				total += transaction.amount;
			}
		}
		return total;
	}


	getWalletInfo(monthInMilliseconds){
		var month = monthInMilliseconds > 0 ? monthInMilliseconds : moment().startOf('month').valueOf();

		getBalance().then(resp => {
			if (resp.data.error === commonErr.SUCCESS) {
				this.setState({					
					balance: resp.data.data.balance
				})
			} else {
				this.setState({
					err: resp.data.error,
				})
			}
		})
		getInvoiceByMonth(month).then(resp => {
			if (resp.data.error === commonErr.SUCCESS){
				this.setState({
					startDate: moment(month).startOf('month').format("DD-MM-YYYY"),
					endDate: moment(month).endOf('month').format("DD-MM-YYYY"),
					transactionsFinished: resp.data.data.transactionsFinished,
					transactionsCanceled: resp.data.data.transactionsCanceled,
					transactionsOther: resp.data.data.transactionsOther,
					totalTripFinished: resp.data.data.totalTripFinished,
					// rating: resp.data.data.rating.avg,
					responseRate: resp.data.data.responseRate,
					responseTime: resp.data.data.responseTime,
					acceptRate: resp.data.data.acceptRate,	
					openingBalance: resp.data.data.openingBalance,
					endingBalance: resp.data.data.endingBalance			
				})
			} else {
				this.setState({
					err: resp.data.error,
					data: null
				})
			}
		})
	}


	render() {
	var content;
	const profile = this.props.session.profile;
	const { platformType } = this.props.appInit;	
	const { err, startDate, endDate, transactionsFinished, transactionsOther, transactionsCanceled, endingBalance, openingBalance } = this.state;

	if (err === commonErr.LOADING) {
      content = <LoadingPage />
	} else { 
			const isBiz = platformType === TPlatformType.BIZ;
			const isAgent = platformType === TPlatformType.AGENT;

		
			content = <div className="owner-transaction__wrap ibox-body">
					<div className="main-title"> 
						<a className="btn-back-list" href="/mywallet" title="Quay lại"><i className="i-arr-left-dark"></i></a>
						<h3 className="n-title">SAO KÊ CHI TIẾT GIAO DỊCH</h3>
						<p className="date">Từ ngày <span>{startDate} </span>Đến ngày <span>{endDate}</span></p>
					</div>
					<div className="info-owner__box">
						<div className="info-owner">
							<p>{isBiz ? 'Doanh nghiệp' : 'Đại lý'}</p>
							<p>Mã số</p>
						</div>
						<div className="info-owner">
							<p>{profile.info && profile.info.name}</p>
							<p>{profile.info && profile.info.uid}</p>
						</div>
					</div>
					<div className="trip-completed__wrap"> 
						<h4>Chuyến đi hoàn thành trong kì</h4>
						<div className="trip-completed__table table-responsive"> 
							<table className="table"> 
								<thead>
									<tr> 
										<th colSpan="5">Thời gian</th>
										<th colSpan="3">Thông tin chuyến đi</th>
										<th colSpan={`${isBiz ? 2 : 3}`}>{isBiz ? 'Giao dịch' : 'Doanh thu'}</th>
									</tr>
									<tr> 
										<th>Mã chuyến đi</th>
										<th>Hình thức</th>	
										<th>Ngày đi</th>
										<th>Ngày về </th>
										<th>Ngày đặt xe</th>
										<th>Khách thuê</th>
										<th>Xe thuê</th>
										<th>Đơn giá</th>
										{isBiz ? <th>Phí phát sinh</th> : <th>Tiền thu hộ</th>}
										{isAgent && <th>Hoa hồng</th>}
										<th>Thay đổi số dư</th>
									</tr>
								</thead>
								<tbody>
									{transactionsFinished && transactionsFinished.map((transaction, index) => <tr key={index}> 
										<td><a style={{color: '#00a550'}} href={`/trip/detail/${transaction.trip.id}`} target="_blank">{transaction.trip.id}</a></td>
										<td>{0 < transaction.trip.serviceType < 2 ? <p>Tự lái</p> : <p>Có tài xế</p>}</td>
										<td>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</td>
										<td>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</td>
										<td>{moment(transaction.trip.timeCreated).format("DD/MM/YYYY")}</td>
										<td>{transaction.trip.travelerInfo.travelerName}</td>
										<td>{transaction.trip.carGroup}</td>
										<td><NumberFormat value={transaction.trip.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
										<td><NumberFormat value={transaction.trip.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
										{isAgent && <td><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>}
										<td><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
									</tr> )}			
								</tbody>
								<tfoot>
									<tr> 
										<th colSpan={`${isBiz ? 9 : 10}`}>Tổng thay đổi - Chuyến đi hoàn thành</th>
											<th><NumberFormat value={this.getTotalTrasactionAmount(transactionsFinished)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"}/></th>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div className="transaction-in-month__wrap"> 
						<h4>Giao dịch rút/nộp tiền trong kì</h4>
						<div className="transaction-in-month__table table-responsive"> 
							<table> 
								<thead> 
									<tr> 
										<th>Ngày giao dịch </th>
										<th>Nội dung </th>
										<th>Thay đổi số dư </th>
									</tr>
								</thead>
								<tbody>{transactionsOther && transactionsOther.map((transaction, index) => <tr key={index}>
										<td>{moment(transaction.timeCreated).format("DD/MM/YYYY")}</td>
										<td>{transaction.comment}</td>
										<td><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
									</tr>)}
								</tbody>
								<tfoot> 
									<tr>
										<th colSpan="2">Tổng thay đổi - Giao dịch rút/nộp tiền</th>
										<th><NumberFormat value={this.getTotalTrasactionAmount(transactionsOther)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></th>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div className="cancel-transaction__wrap"> 
						<h4>Giao dịch hủy chuyến trong kì</h4>
						<div className="cancel-transaction__table table-responsive"> 
							<table className="table"> 
								<thead>
									<tr> 
										<th colSpan="4">Thời gian</th>
										<th colSpan="3">Thông tin chuyến đi</th>
										<th colSpan="1">Thanh toán</th>
										<th rowSpan="2"> Nội dung hủy chuyến</th>
										<th rowSpan="2"> Thay đổi số dư</th>
									</tr>
									<tr> 
										<th>Mã chuyến đi</th>
										<th>Ngày đi</th>
										<th>Ngày về </th>
										<th>Ngày hủy chuyến</th>
										<th>Khách thuê</th>
										<th>Xe thuê</th>
										<th>Đơn giá</th>
										{isBiz ? <th>Phí phát sinh</th> : <th>Tiền thu hộ</th>}
										{/* <th>Hoa hồng</th> */}
										{/* <th>Phí phát sinh</th> */}
									</tr>
								</thead>
									<tbody>{transactionsCanceled && transactionsCanceled.map((transaction, index) => <tr key={index}> 
											<td><a style={{color: '#00a550'}} href={`/trip/detail/${transaction.trip.id}`} target="_blank">{transaction.trip.id}</a></td>
											<td>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</td>
											<td>{moment(transaction.trip.tripDateFrom).format("DD/MM/YYYY")}</td>
											<td>{moment(transaction.trip.timeCreated).format("DD/MM/YYYY")}</td>
											<td>{transaction.trip.travelerInfo.travelerName}</td>
											<td>{transaction.trip.carGroup}</td>
											<td><NumberFormat value={transaction.trip.price} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
											<td><NumberFormat value={transaction.trip.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
											{/* <td><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td> */}
											<td>{transaction.trip.reasonCanceled}</td>
											<td><NumberFormat value={transaction.amount} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></td>
									</tr>)}
								</tbody>
								<tfoot>
									<tr> 
										<th colSpan="9">Tổng thay đổi - Giao dịch hủy chuyến</th>
										<th><NumberFormat value={this.getTotalTrasactionAmount(transactionsCanceled)} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></th>
									</tr>
								</tfoot>
							</table>
						</div>
					</div>
					<div className="owner-report">
						<div className="group-summary">
							<div className="transaction-summary">
								<p>TỔNG CỘNG THAY ĐỔI TRONG KÌ</p>
								<p><NumberFormat value={endingBalance - openingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
							</div>
							<div className="transaction-summary">
								<p>TIỀN ĐẦU KÌ</p>
								<p><NumberFormat value={openingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
							</div>
							<div className="transaction-summary">
								<p>TIỀN CUỐI KÌ</p>
								<p className="sum-price"><NumberFormat value={endingBalance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
							</div>
						</div>
					</div>
					<p className="note">Ghi chú: Mọi vấn đề thắc mắc về thông tin ghi nhận trên bản sao kê chi tiết giao dịch, Quý đối tác vui lòng liên hệ với bộ phận Chăm Sóc Khách Hàng của Mioto tại 19009217 để biết thêm chi tiết. Xin cám ơn!</p>
				</div>
		}
		return 	<div className="mioto-layout page-wrapper">
							<Header />
							<SideBar /> 
							<div className="content-wrapper">
								<div className="page-content fade-in-up">
										<div className="ibox">
										{content}
										</div>
									</div>
							<Footer />
							</div>
						</div>
	}
}

function mapState(state) {
		return {
				appInit: state.appInit,
        session: state.session
    }
}

MyMonthlyReport = connect(mapState)(MyMonthlyReport)

export default MyMonthlyReport


// WEBPACK FOOTER //
// ./src/components/account/mymonthlyreport.js